import request from '@/utils/request'

export function findResult(key_words) {
    return request({
        url: '/web/index/get_find_result',
        method: 'post',
        data: {
            key_words: key_words
        }
    })
}
export function schoolRank(rank_type) {
    return request({
        url: '/web/school_rank/index',
        method: 'post',
        data: {
            rank_type: rank_type
        }
    })
}
export function schoolNews() {
    return request({
        url: '/web/news/index',
        method: 'post',
        data: {
            area: localStorage.getItem('area')
        }
    })
}
export function getHistoryData() {
    return request({
        url: '/web/Sim/getHistoryData',
        method: 'post',
        data: {
            area: localStorage.getItem('area')
        }
    })
}
export function recommendSchool(scl_nature_type) {
    return request({
        url: '/web/school_rank/recommendSchool',
        method: 'post',
        data: {
            scl_nature_type: scl_nature_type,
            area: localStorage.getItem('area')
        }
    })
}
export function getRecomendVideo() {
    return request({
        url: '/web/video/getRecomendVideo',
        method: 'post',
        data: {
        }
    })
}
export function getEvaluationTimes() {
    return request({
        url: '/web/psytest/lst',
        method: 'post',
        data: {
        }
    })
}
export function saveUserName(data) {
    return request({
        url: '/web/other/saveUserName',
        method: 'post',
        data: {
            user_name: data.user_name
        }
    })
}

export function getWebsite(domain) {
    return request({
        url: '/web/index',
        method: 'post',
        data: {
            domain: domain
        }
    })
}

export function getArea(year) {
    return request({
        url: '/web/area',
        method: 'post',
        data: {
            year: year
        }
    })
}

export function getBatch(form) {
    return request({
        url: '/web/batch',
        method: 'post',
        data: {
            area: form.area,
            year: form.year,
            scl_id: form.scl_id || '',
        }
    })
}